import { dispatcher } from './dispatcher'

window.appDispatcher = dispatcher
